// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero-wrapper {
  position: relative;
  background-color: var(--hero-bg-color);
  min-height: calc(var(--hero-height-mobile));
  width: 100%;
  display: flex;
  align-items: center;
  margin-top: calc(var(--navbar-height-mobile) * -1);
  padding-top: var(--navbar-height-mobile);
}
@media (min-width: 1200px) {
  .hero-wrapper {
    min-height: calc(var(--hero-height-desktop));
    margin-top: calc(var(--navbar-height-desktop) * -1);
    padding-top: var(--navbar-height-desktop);
  }
}
.hero-wrapper .hero-container {
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 0;
  top: 0;
  left: 0;
}
.hero-wrapper .hero-container.withAnimation {
  transition: all var(--hero-bg-image-animation-duration);
}
.hero-wrapper .hero-container.withAnimation.isExecutable {
  opacity: 1;
}
.hero-wrapper .hero-container.isImage {
  background-size: cover;
  background-image: var(--hero-bg-xxl) !important;
  background-position: var(--hero-background-position-desktop);
}
@media (max-width: 767px) {
  .hero-wrapper .hero-container.isImage {
    background-image: var(--hero-bg-mobile) !important;
    background-position: var(--hero-background-position-mobile);
  }
}
.hero-wrapper .hero-contents {
  display: flex;
  flex-wrap: wrap;
  text-align: center;
}
.hero-wrapper .hero-contents > * {
  margin: 0;
}
.hero-wrapper .hero-contents.centered {
  justify-content: center;
  text-align: center;
}
.hero-wrapper .hero-contents.centered .hero-contents__cta-container {
  justify-content: center;
}
@media (min-width: 768px) {
  .hero-wrapper .hero-contents.centered {
    justify-content: center;
    padding: 0;
  }
}
@media (min-width: 1200px) {
  .hero-wrapper .hero-contents {
    text-align: left;
  }
}
.hero-wrapper .hero-contents__title {
  width: 100%;
  font-weight: 700 !important;
  color: var(--hero-title-color) !important;
  font-size: var(--hero-title-font-size-mobile) !important;
  margin: 0px !important;
  margin-bottom: 5px !important;
}
@media (min-width: 1200px) {
  .hero-wrapper .hero-contents__title {
    font-size: var(--hero-title-font-size-desktop) !important;
  }
}
.hero-wrapper .hero-contents__subtitle {
  width: 100%;
  font-weight: 700 !important;
  color: var(--hero-subtitle-color) !important;
  margin: 5px 0px 20px !important;
  font-size: var(--hero-subtitle-font-size-mobile) !important;
}
@media (min-width: 1200px) {
  .hero-wrapper .hero-contents__subtitle {
    font-size: var(--hero-subtitle-font-size-desktop) !important;
  }
}
.hero-wrapper .hero-contents__live-date {
  width: 100%;
  font-weight: var(--hero-date-font-weight) !important;
  color: var(--hero-date-color) !important;
  font-size: var(--hero-date-font-size-mobile) !important;
  margin: 0px !important;
}
@media (min-width: 1200px) {
  .hero-wrapper .hero-contents__live-date {
    font-size: var(--hero-date-font-size-desktop) !important;
  }
}
.hero-wrapper .hero-contents__vod-date {
  width: 100%;
  font-weight: var(--hero-vod-date-font-weight) !important;
  color: var(--hero-date-color) !important;
  font-size: var(--hero-vod-date-font-size-mobile) !important;
  margin: 0px !important;
  margin-top: 5px !important;
}
@media (min-width: 1200px) {
  .hero-wrapper .hero-contents__vod-date {
    font-size: var(--hero-vod-date-font-size-desktop) !important;
  }
}
.hero-wrapper .hero-contents__cta-container {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 1rem;
}
.hero-wrapper .hero-contents .hero-login-button,
.hero-wrapper .hero-contents .hero-register-button {
  margin-top: 20px;
  padding-left: 50px;
  padding-right: 50px;
  background-color: var(--hero-login-button-bg-color) !important;
  color: var(--hero-login-button-text-color) !important;
  border-color: var(--hero-login-button-border-color) !important;
}
.hero-wrapper .hero-contents .hero-login-button:hover,
.hero-wrapper .hero-contents .hero-register-button:hover {
  background-color: var(--hero-login-button-bg-color-hover) !important;
  color: var(--hero-login-button-text-color-hover) !important;
  border-color: var(--hero-login-button-border-color-hover) !important;
}
.hero-wrapper .hero-scroll-down-button {
  cursor: pointer;
  transform: translate(-50%);
  position: absolute;
  bottom: 20px;
  left: 50%;
  flex-direction: column;
  display: none;
}
.hero-wrapper .hero-scroll-down-button--mobile {
  display: flex;
}
@media (min-width: 1200px) {
  .hero-wrapper .hero-scroll-down-button {
    display: none;
  }
}
@media (min-width: 1200px) {
  .hero-wrapper .hero-scroll-down-button--desktop {
    display: flex;
  }
}
.hero-wrapper .hero-scroll-down-icon {
  animation: pointDown 2.5s infinite;
  -webkit-animation: pointDown 2.5s infinite;
  color: var(--hero-title-color);
  font-size: 20px;
  transform: scale(1.6, 0.8);
  margin-top: -15px;
}
@media (min-width: 1200px) {
  .hero-wrapper .hero-scroll-down-icon {
    font-size: 30px;
  }
}
.hero-wrapper .hero-scroll-down-icon--1 {
  animation-delay: -1s;
  -webkit-animation-delay: -1s;
}
.hero-wrapper .hero-scroll-down-icon--2 {
  animation-delay: -0.5s;
  -webkit-animation-delay: -0.5s;
}
.hero-wrapper .hero-scroll-down-icon--3 {
  animation-delay: 0s;
  -webkit-animation-delay: 0s;
}

@keyframes pointDown {
  0% {
    opacity: 0;
  }
  40% {
    opacity: 1;
  }
  80% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
@-webkit-keyframes pointDown {
  0% {
    opacity: 0;
  }
  40% {
    opacity: 1;
  }
  80% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/blocks/Hero/Hero.scss"],"names":[],"mappings":"AAEA;EACI,kBAAA;EACA,sCAAA;EACA,2CAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EAGA,kDAAA;EACA,wCAAA;AAHJ;AAKI;EAZJ;IAaQ,4CAAA;IACA,mDAAA;IACA,yCAAA;EAFN;AACF;AAII;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,MAAA;EACA,OAAA;AAFR;AAIQ;EACI,uDAAA;AAFZ;AAIY;EACI,UAAA;AAFhB;AAMQ;EACI,sBAAA;EACA,+CAAA;EACA,4DAAA;AAJZ;AAMY;EALJ;IAMQ,kDAAA;IACA,2DAAA;EAHd;AACF;AAOI;EACI,aAAA;EACA,eAAA;EACA,kBAAA;AALR;AAOQ;EACI,SAAA;AALZ;AAQQ;EACI,uBAAA;EACA,kBAAA;AANZ;AAQY;EACI,uBAAA;AANhB;AASY;EARJ;IASQ,uBAAA;IACA,UAAA;EANd;AACF;AASQ;EAvBJ;IAwBQ,gBAAA;EANV;AACF;AAQQ;EACI,WAAA;EACA,2BAAA;EACA,yCAAA;EACA,wDAAA;EACA,sBAAA;EACA,6BAAA;AANZ;AAQY;EARJ;IASQ,yDAAA;EALd;AACF;AAQQ;EACI,WAAA;EACA,2BAAA;EACA,4CAAA;EACA,+BAAA;EACA,2DAAA;AANZ;AAQY;EAPJ;IAQQ,4DAAA;EALd;AACF;AAQQ;EACI,WAAA;EACA,oDAAA;EACA,wCAAA;EACA,uDAAA;EACA,sBAAA;AANZ;AAQY;EAPJ;IAQQ,wDAAA;EALd;AACF;AAQQ;EACI,WAAA;EACA,wDAAA;EACA,wCAAA;EACA,2DAAA;EACA,sBAAA;EACA,0BAAA;AANZ;AAQY;EARJ;IASQ,4DAAA;EALd;AACF;AAQQ;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,SAAA;AANZ;AASQ;;EAEI,gBAAA;EACA,kBAAA;EACA,mBAAA;EAEA,8DAAA;EACA,qDAAA;EACA,8DAAA;AARZ;AAUY;;EACI,oEAAA;EACA,2DAAA;EACA,oEAAA;AAPhB;AAYI;EACI,eAAA;EACA,0BAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,sBAAA;EACA,aAAA;AAVR;AAYQ;EACI,aAAA;AAVZ;AAaQ;EAbJ;IAcQ,aAAA;EAVV;AACF;AAaY;EADJ;IAEQ,aAAA;EAVd;AACF;AAcI;EACI,kCAAA;EACA,0CAAA;EACA,8BAAA;EACA,eAAA;EACA,0BAAA;EACA,iBAAA;AAZR;AAcQ;EARJ;IASQ,eAAA;EAXV;AACF;AAaQ;EACI,oBAAA;EACA,4BAAA;AAXZ;AAcQ;EACI,sBAAA;EACA,8BAAA;AAZZ;AAeQ;EACI,mBAAA;EACA,2BAAA;AAbZ;;AAkBA;EACI;IACI,UAAA;EAfN;EAiBE;IACI,UAAA;EAfN;EAiBE;IACI,UAAA;EAfN;EAiBE;IACI,UAAA;EAfN;AACF;AAkBA;EACI;IACI,UAAA;EAhBN;EAkBE;IACI,UAAA;EAhBN;EAkBE;IACI,UAAA;EAhBN;EAkBE;IACI,UAAA;EAhBN;AACF","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
